import sessions from "./sessions";
import visits from "./visits";

export const statistics = {
    sessions,
    visits,
};

export default statistics;
